import { Flex } from 'components/flex';
import { Badge } from 'components/badge';
import { EventCheckout } from 'store/api/event';
import { BadgeColor, CheckoutType, BadgePadding } from 'types';
import { RefundStatusBadge } from 'components/refund-status-badge';

export const CheckoutLabels = ({
  column,
  checkout,
}: {
  column?: boolean;
  checkout?: EventCheckout;
}) => {
  const isExchange = checkout?.type === CheckoutType.Exchange;

  return (
    <Flex gap={8} column={column}>
      {isExchange && <Badge text="Exchange" styleType={BadgeColor.Blue} />}

      {!!checkout?.shippingPrice && (
        <Badge text="Shipping" styleType={BadgeColor.TetrieryBlue} />
      )}

      {!!checkout?.refund?.length && (
        <RefundStatusBadge
          refunds={checkout?.refund}
          padding={BadgePadding.Default}
        />
      )}

      {checkout?.isVoided && <Badge text="Voided" styleType={BadgeColor.Red} />}
    </Flex>
  );
};
